import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import {ButtonStyle} from 'ui-library/buttons/Button';
import * as ModalContainer from 'ui-library/ModalContainer';
import Modal from 'ui-library/modals/Modal';
import {InputChangeEvent} from 'util/Types';

interface Option {
  text: string;
  value: string;
}

interface SelectOptionModalBodyProps {
  preamble?: React.ReactNode;
  options: Array<Option>;
  selectedOption?: string | null;
  onSelectOption: (selectedOption: string) => void;
}

export interface SelectOptionModalProps {
  buttonStyle?: ButtonStyle;
  initialOption?: string | null;
  onRequestClose: () => void;
  onSubmit: (selectedOption?: string | null) => void;
  options: Array<Option>;
  preamble?: React.ReactNode;
  title: string;
}

interface State {
  selectedOption?: string | null;
}

export function SelectOptionModalBody(props: SelectOptionModalBodyProps): JSX.Element {
  function handleOptionChange(e: InputChangeEvent): void {
    const selectedOption = e.target.value;
    props.onSelectOption(selectedOption);
  }

  return (
    <div>
      <div>{props.preamble}</div>
      {props.options.map((option) => (
        <div className="radio" key={option.value}>
          <label>
            <input
              checked={props.selectedOption === option.value}
              onChange={handleOptionChange}
              type="radio"
              value={option.value}
              {...getTestProps({component: 'SelectOptionModalBody', element: option.value})}
            />
            {option.text}
          </label>
        </div>
      ))}
    </div>
  );
}

export default class SelectOptionModal extends React.Component<SelectOptionModalProps> {
  static defaultProps = {buttonStyle: ButtonStyle.PRIMARY, initialOption: null};

  state: State = {selectedOption: this.props.initialOption};

  static open(props: Omit<SelectOptionModalProps, 'onRequestClose'>): void {
    const modalProps = {
      ...props,
      onRequestClose: () => {
        ModalContainer.close(SelectOptionModal);
      },
    };
    ModalContainer.open(SelectOptionModal, <SelectOptionModal {...modalProps} />);
  }

  private handleSubmit = (): void => {
    this.props.onSubmit(this.state.selectedOption);
    this.props.onRequestClose();
  };

  render(): JSX.Element {
    return (
      <Modal
        buttons={[
          {
            disabled: !this.state.selectedOption,
            text: 'Done',
            style: this.props.buttonStyle,
            submit: true,
          },
        ]}
        onRequestClose={this.props.onRequestClose}
        onRequestSubmit={this.handleSubmit}
        showFooterBorder={false}
        title={this.props.title}
        wrapInForm={false}
      >
        <SelectOptionModalBody
          preamble={this.props.preamble}
          options={this.props.options}
          selectedOption={this.state.selectedOption}
          onSelectOption={(selectedOption) => {
            this.setState({selectedOption});
          }}
        />
      </Modal>
    );
  }
}
